import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../../utils/services/auth.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit, OnDestroy {
  title = 'verity-prices';
  companyName = '';
  companyLogoUrl;
  logoUrlSubscription: Subscription;
  currentDate = new Date();

  constructor(public authService: AuthService) {
  }

  ngOnInit(): void {
    this.initLogoUrl();
  }

  ngOnDestroy(): void {
    this.logoUrlSubscription.unsubscribe();
  }

  onLogoutClicked() {
    localStorage.removeItem('verity_user');
    localStorage.removeItem('verity_token');

    window.open('https://www.akceso.pro/?auth=logoff');
  }

  private initLogoUrl() {
    this.logoUrlSubscription = this.authService.onLogoReceived().subscribe(companyName => {
      this.companyName = companyName;
      this.companyLogoUrl = 'https://www.akceso.pro/tools/web/img/Logo_' + companyName + '.png';
    });
  }
}
